import React, {useState, useEffect, useContext} from "react";
import axios from "../common/axios";
import ListItem from "../common/ListItem";
import ListGroup from "../common/ListGroup";
import {ContentContext} from "../common/ContentContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import CircularLoader from "../common/CircularLoader";

const CMSResourceNavigation = props => {
    const {shortcutLocation} = props;
    const {content,mediaLocation} = useContext(ContentContext);
    const [resources, setResources] = useState({});
    const [questionSearchType, setQuestionSearchType] = useState();
    const [mediaSearchType, setMediaSearchType] = useState();
    const [glossaryTermId, setGlossaryTermId] = useState();
    const [glossaryTerms, setGlossaryTerms] = useState([]);
    const [searchParams, setSearchParams] = useState({});
    const [questionResourceName, setQuestionResourceName] = useState('Questions');
    const [mediaResourceName, setMediaResourceName] = useState('Media');
    const {loadShortcutByUrl} = useCurrentShortcut();

    const handleQuestionClick = (type) => {
        let url = '/administration/question/manageQuestions.action';

        delete searchParams['mediaType'];
        searchParams.questionSearchType = type;

        loadShortcutByUrl(url, searchParams);

        if (questionSearchType !== null && type !== questionSearchType) {
            window.dispatchEvent(new CustomEvent('cmsQuestionSearchRefresh', {detail: [{name: "questionSearchType", value: type}]}));
        }

        setQuestionSearchType(type);
    }

    const handleQuestionClusterClick = () => {
        let url = '/administration/question/manageQuestionClusters.action';

        delete searchParams['mediaType'];
        delete searchParams['questionSearchType'];

        loadShortcutByUrl(url, searchParams);
    }

    const handleMediaClick = (type) => {
        let url = '/administration/media/showManageMedia.action';

        delete searchParams['questionSearchType'];
        searchParams.mediaType = type;

        loadShortcutByUrl(url, searchParams);

        if (mediaSearchType !== null && type !== mediaSearchType) {
            window.dispatchEvent(new CustomEvent('cmsMediaSearchRefresh', {detail: [{name: "mediaSearchParameters.mediaType", value: type}]}));
        }

        setMediaSearchType(type);
    }

    const handleGlossaryClick = (termId) => {
        let url = '/administration/glossary/manageGlossary.action',
            params = {glossaryTermId: termId, mediaLocation: mediaLocation, loadGlossaryTermFromCMS: true};

            loadShortcutByUrl(url, params);

            if (glossaryTermId !== null && termId != glossaryTermId) {
                window.dispatchEvent(new CustomEvent('cmsGlossaryTermRefresh', {detail: termId}));
            }

            setGlossaryTermId(termId);
    }

    useEffect(() => {
        setResources({});
        setGlossaryTerms([]);
        setMediaResourceName('Resources');
        if (mediaLocation === 'CONCEPT') {
            if (content.currentConcept !== undefined) {
                axios.get('/web/ui/content/concept/resourceCounts', {params: {conceptId: content.currentConcept.conceptId}})
                    .then(response => {
                        setResources(response.data);
                    });

                axios.get('/web/ui/content/concept/getGlossaryTerms', {params: {conceptId: content.currentConcept.conceptId}})
                    .then(response => {
                        setGlossaryTerms(response.data);
                    });

                setMediaResourceName('Media');
                setSearchParams({conceptId: content.currentConcept.conceptId, showResults: true, mediaLocation: mediaLocation});
            }
        } else if (mediaLocation === 'TOPIC') {
            if (content.currentTopic !== undefined) {
                axios.get('/web/ui/content/topic/resourceCounts', {params: {topicId: content.currentTopic.topicId}})
                    .then(response => {
                        setResources(response.data);
                    });

                setSearchParams({topicId: content.currentTopic.topicId, showResults: true, mediaLocation: mediaLocation});
            }
        } else if (mediaLocation === 'SYLLABUS') {
            if (content.currentSyllabus !== undefined) {
                axios.get('/web/ui/content/syllabus/resourceCounts', {params: {syllabusId: content.currentSyllabus.syllabusId}})
                    .then(response => {
                        setResources(response.data);
                    });

                setSearchParams({syllabusId: content.currentSyllabus.syllabusId, showResults: true, mediaLocation: mediaLocation});
            }
        }
    }, [content, mediaLocation]);

    if (glossaryTerms.length === 0 && resources["QUESTIONS"] === undefined && resources["MEDIA"] === undefined) {
        return null;
    }

    return (
        <ul className={'ch-list ch-nav-divided'}>
            {resources["QUESTIONS"] !== undefined &&
                <ListGroup title={questionResourceName} startOpen={false}>
                    {resources["QUESTIONS"].map((questionResource, index) => (
                        <ListItem key={index} onClick={() => {
                            if (questionResource.questionSearchType != null) {
                                handleQuestionClick(questionResource.questionSearchType)
                            } else {
                                handleQuestionClusterClick();
                            }
                        }}>
                            {questionResource.title} ({questionResource.count})
                        </ListItem>
                    ))}
                </ListGroup>
            }
            {resources["MEDIA"] !== undefined &&
                <ListGroup title={mediaResourceName} startOpen={false}>
                    {resources["MEDIA"].map((mediaResource, index) => (
                        <ListItem key={index} onClick={() => {handleMediaClick(mediaResource.mediaType)}}>
                            {mediaResource.title} ({mediaResource.count})
                        </ListItem>
                    ))}
                </ListGroup>
            }
            {glossaryTerms.length > 0 &&
                <ListGroup title={'Glossary'} startOpen={false}>
                    {glossaryTerms.map((term, index) => (
                        <ListItem key={term.glossaryTermId} onClick={() => {handleGlossaryClick(term.glossaryTermId)}}>
                            {term.glossaryTerm}
                        </ListItem>
                    ))}
                </ListGroup>
            }
        </ul>
    );
}

export default CMSResourceNavigation;